export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '450px',
    minHeight: '350px',
    maxWidth: '450px',
    maxHeight: '380px',  
    borderRadius: '8px',
    padding: '12px',
  },
};

export const customStylesSelector = {
  control: (base, state) => ({
    ...base,
    borderColor: 'lightGray',
    borderRadius: '8px',
    boxShadow: 'none',
    minHeight: '37px',
    width: '60%',
    cursor: 'notAllowed',
    paddingLeft: '8px',
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: '20',
  }),
  menuList: () => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 'none!important',
  }),
  valueContainer: (base, state) => ({
    display: 'flex',
    paddingLeft: '5px',
    maxWidth: '224px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignItems: 'center',
  }),
  container: (base, state) => ({
    ...base,
    pointerEvents: 'auto',
  }),
  singleValue: (base, state) => ({
    maxWidth: '224px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    margin: '4px 0',
  }),
  options: (base, state) => ({
    padding: '4px 8px',
    cursor: 'pointer',
    borderRadius: 'unset',
  }),
};

export const SelectPriceStyles = (isDuplicate) => ({
  control: (base, state) => ({
  ...base,
  borderStyle: 'none',
  minWidth: 'unset',
  minHeight: '22px',
  paddingLeft: '4px',
  height: '16px',
  boxShadow: '0 0 0 0 #ffffff',
  alignContent: 'center',
}),
menu: (base, state) => ({
  ...base,
}),
menuList: () => ({
  position: 'fixed',
  height: '350px!important',
  overflowY: 'auto',
}),
input: (base, state) => ({
  ...base,
  height: 0,
  position: 'absolute',
  top: '0',
  marginTop: '-2px',
}),
valueContainer: (base, state) => ({
  display: 'flex',
  alignItems: 'self-end',
  paddingLeft: '0',
  maxWidth: '144px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: isDuplicate ? 'red' : 'inherit'
}),
container: (base, state) => ({
  ...base,
  pointerEvents: 'auto',
}),
singleValue: (base, state) => ({
  maxWidth: '144px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  margin: '4px 0',
  fontWeight: 'bold',
}),
option: (defaultStyles, state) => ({
  ...defaultStyles,
  backgroundColor: state.isSelected ? "lightGrey" : "#fff",
  border: '1px solid lightGray',
  borderRadius: '3px',
  padding: '4px',
  minHeight: '24px',
}),
indicatorsContainer: () => ({
  height: 'max-content',
}),
dropdownIndicator: (defaultStyles) => ({
  ...defaultStyles,
  padding: '0 2px 0 0!important',
}),
});

export const customSelectStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? 'lightGray' : 'lightGray',
    borderRadius: '8px',
    boxShadow: 'none',
    minHeight: '30px',
    width: '100%',
    cursor: 'notAllowed',
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: '20',
  }),
  menuList: (base) => ({
    ...base,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 'none!important',
    maxHeight: '250px',
    overflowY: 'auto',
  }),
  valueContainer: (base, state) => ({
    display: 'flex',
    alignItems: 'self-end',
    paddingLeft: '10px',
    maxWidth: '224px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  container: (base, state) => ({
    ...base,
    pointerEvents: 'auto',
  }),
  singleValue: (base, state) => ({
    maxWidth: '224px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    margin: '4px 0',
  }),
  options: (base, state) => ({
    padding: '4px 8px',
    cursor: 'pointer',
    borderRadius: 'unset',
  }),
  indicatorsContainer: () => ({
    height: 'max-content',
  }),
  dropdownIndicator: (defaultStyles) => ({
    ...defaultStyles,
    padding: '0 2px 0 0!important',
  }),
};

export const editModalCustomStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '350px',
    maxWidth: '420px',
    minHeight: '250px',
    borderRadius: '8px',
    padding: '0',
    textAlign: 'center',
  },
};